import instance from "../api/instance";
import { logout } from "./sessionActions";
import { queryString, getFilters } from "../../components/utils/functions";

import {
  GET_BILLS,
  CLEAR_BILLS_LIST,
  GET_PROVIDER_BILLS,
  GET_BILL_BY_ID,
} from "../constants/constants";

export const getBillsList = (
  page = 0,
  size = 10,
  filters = [],
  sort = "id,DESC",
  valueStatus = "DELETED" // '', null or false for not set initial state
) => {
  let customFilters = [...filters];
  if (valueStatus) {
    customFilters.push({
      property: "status",
      operator: "not",
      value: valueStatus,
    });
  }
  var searchFilters = getFilters(customFilters);
  var queryFilters = [{ property: "sort", value: sort }];

  if (searchFilters !== "") {
    queryFilters.push({ property: "search", value: searchFilters });
  }

  var url = `/bills/company?page=${page}&size=${size}&${queryString(
    queryFilters
  )}`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_BILLS,
          bills: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getBillById = (id) => {
  return (dispatch) => {
    return instance
      .get(`/bills/${id}`)
      .then((response) => {
        dispatch({
          type: GET_BILL_BY_ID,
          bills: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getProviderBills = (
  page = 0,
  size = 10,
  filters = [],
  sort = "id,DESC"
) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "sort", value: sort }];

  if (searchFilters !== "") {
    queryFilters.push({ property: "search", value: searchFilters });
  }

  var url = `/bills/provider?page=${page}&size=${size}&${queryString(
    queryFilters
  )}`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_PROVIDER_BILLS,
          bills: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const clearBillsList = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_BILLS_LIST,
    });
};
